import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnNG: CultureInfo = {
  name: 'en-NG',
  displayName: 'English (Nigeria)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-NG',
  parent: CultureInfoEn
};
